module.exports = {"141027100":"天坛镇","141027101":"响水河镇","141027102":"张庄镇","141027103":"北王镇","141027201":"东张乡","141027202":"槐埝乡","141027206":"寨圪塔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141027.json
// module id = 456
// module chunks = 0